import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { getGetExtractionQueryOptions } from '@sara/api-client';
import { ExtractionDetail } from '../../components/ExtractionDetail/ExtractionDetail';
import { toSuspense } from '../../../../lib/query';
import { useOrgSlug } from '../../../auth';

interface ExtractionDetailContainerProps {
  extractionId: string;
}

function ExtractionDetailSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-10 w-64" />
      <Skeleton className="h-[200px] rounded-lg" />
      <Skeleton className="h-[200px] rounded-lg" />
    </div>
  );
}

function ExtractionDetailContainerContent({ extractionId }: ExtractionDetailContainerProps) {
  const { data } = useSuspenseQuery(toSuspense(getGetExtractionQueryOptions(extractionId)));
  const navigate = useNavigate();
  const orgSlug = useOrgSlug();

  return (
    <ExtractionDetail
      extraction={data}
      onCreateVersion={() =>
        navigate({
          to: '/orgs/$orgSlug/extractions/$extractionId/edit',
          params: { orgSlug, extractionId },
        })
      }
    />
  );
}

export function ExtractionDetailContainer({ extractionId }: ExtractionDetailContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<ExtractionDetailSkeleton />}>
        <ExtractionDetailContainerContent extractionId={extractionId} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
